import React from 'react'
import '../style/kontakt.css'

const Kontakt = () => {
  return (
    <section className="kontakt-section">
      <div className="kontakt-info">
        <h2>Skontaktuj się z nami</h2>

        <p>
          <strong>Adres:</strong><br />
          ul. Plażowa 3<br />
          34-360 Milówka
        </p>

        <p>
          <strong>Telefon:</strong><br />
          <a href="tel:+48666691526">+48 666 691 526</a>
        </p>

        <p>
          <strong>Email:</strong><br />
          <a href="mailto:mtt.ubezpieczenia@gmail.com">mtt.ubezpieczenia@gmail.com</a><br />
          <a href="mailto:malgorzata.tyc@onet.eu">malgorzata.tyc@onet.eu</a>
        </p>

        <div className="godziny">
          <strong>Godziny otwarcia:</strong>
          <ul>
            <li>poniedziałek – 16:00–18:00</li>
            <li>wtorek – 16:00–18:00</li>
            <li>środa – 16:00–18:00</li>
            <li>czwartek – 16:00–18:00</li>
            <li>piątek – 16:00–18:00</li>
          </ul>
        </div>
      </div>

      <div className="kontakt-mapa">
        <iframe
          title="Lokalizacja biura"
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2587.663001385373!2d19.090005700000003!3d49.5663815!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47143bc6ac5f7da1%3A0x94bd1f60439f8f23!2sMTT%20Ubezpieczenia!5e0!3m2!1spl!2spl!4v1749156515844!5m2!1spl!2spl"
          allowFullScreen=""
          loading="lazy"
        ></iframe>
      </div>
    </section>
  )
}

export default Kontakt
